import { NO_ASSETS_FOUND_MESSAGE } from '../../constants';
import NoAssetsImage from '../../assets/images/NoAssetsFound.svg';
interface NoAssetsScreenProps {
    source?: string;
}
const NoAssetsScreen: React.FC<any> = ({ source }) => {
    return (
        <div className="h-full w-full mt-[5%] ml-12 flex flex-col items-center justify-center">
            <img
                className={`${source === 'resource viewer' ? 'h-[30%] w-[30%]' : 'h-[10rem] w-full'}`}
                src={NoAssetsImage}
                alt={NO_ASSETS_FOUND_MESSAGE}
            />
            <p className="mt-2 text-xl">{NO_ASSETS_FOUND_MESSAGE}!</p>
        </div>
    );
};

export default NoAssetsScreen;
